/**
 * 极简云（Useasy）H5 在线客服
 * https://help.useasy.cn/developer/webchat/online_service
 */

import { getUseasyAgentBinding } from "@/api/theApi";
import { Toast } from "vant";

export const USEASY_CHANNEL_ID = "tk6wjO9XyKCZWkbP";
export const USEASY_CREATE_CUSTOMER = true;

const USEASY_H5_ORIGIN = "https://im.useasy.cn";
const PHONE_RE = /^1\d{10}$/;

function plainObject(v) {
  return v && typeof v === "object" && !Array.isArray(v) ? v : {};
}

/**
 * @param {object} opts
 * @param {string} [opts.queueNumber] 来自 data.to_group
 * @param {object} [opts.otherParams] 来自 data.other_params，原样透传 IM otherParams
 * @returns {string|null}
 */
export function buildUseasyWebChatUrl(opts = {}) {
  const channelId = (USEASY_CHANNEL_ID || "").trim();
  if (!channelId) {
    return null;
  }
  const visitorId = String(opts.visitorId || "guest").trim() || "guest";
  const visitorName = String(opts.visitorName || "访客").trim() || "访客";

  const userParamsObj = {
    visitorName,
    visitorId,
  };
  if (USEASY_CREATE_CUSTOMER) {
    userParamsObj.createCustomer = true;
  }
  const queueNumber =
    opts.queueNumber != null ? String(opts.queueNumber).trim() : "";
  if (queueNumber) {
    userParamsObj.queueNumber = queueNumber;
  }

  const imUrlTitle =
    opts.imUrlTitle != null && opts.imUrlTitle !== ""
      ? String(opts.imUrlTitle)
      : typeof document !== "undefined"
        ? document.title || ""
        : "";
  const imFromUrl =
    opts.imFromUrl != null
      ? String(opts.imFromUrl)
      : typeof window !== "undefined"
        ? window.location.href || ""
        : "";

  const qs = [
    "channelId=" + encodeURIComponent(channelId),
    "imUrlTitle=" + encodeURIComponent(imUrlTitle),
    "imFromUrl=" + encodeURIComponent(imFromUrl),
    "userParams=" + encodeURIComponent(JSON.stringify(userParamsObj)),
  ];

  const otherParams = plainObject(opts.otherParams);
  if (Object.keys(otherParams).length) {
    qs.push(
      "otherParams=" + encodeURIComponent(JSON.stringify(otherParams))
    );
  }

  return USEASY_H5_ORIGIN + "/?" + qs.join("&");
}

export async function resolveUseasyBindingParams(phone) {
  const p = String(phone || "").trim();
  if (!PHONE_RE.test(p)) {
    return {};
  }
  try {
    const res = await getUseasyAgentBinding(p);
    if (!res || !res.success || !res.data) {
      return {};
    }
    const d = res.data;
    const out = {};
    if (d.to_group != null && String(d.to_group).trim()) {
      out.queueNumber = String(d.to_group).trim();
    }
    const otherParams = plainObject(d.other_params);
    if (Object.keys(otherParams).length) {
      out.otherParams = otherParams;
    }
    return out;
  } catch (e) {
    console.warn("resolveUseasyBindingParams failed", e);
    return {};
  }
}

/**
 * @param {object} [ctx]
 * @param {string} [ctx.imUrlTitle]
 * @param {string} [ctx.imFromUrl]
 */
export async function openUseasyWebChat(ctx = {}) {
  try {
    const username = String(localStorage.getItem("username") || "").trim();
    const binding = username ? await resolveUseasyBindingParams(username) : {};

    const buildOpts = {
      queueNumber: binding.queueNumber,
      otherParams: binding.otherParams,
      imUrlTitle: ctx.imUrlTitle,
      imFromUrl: ctx.imFromUrl,
    };
    if (username) {
      buildOpts.visitorId = username;
      buildOpts.visitorName = username;
    }

    const h5Url = buildUseasyWebChatUrl(buildOpts);
    console.log("[Useasy IM] 完整链接", h5Url);
    if (!h5Url) {
      Toast("打开客服失败，请稍后重试");
      return;
    }
    window.location.href = h5Url;
  } catch (e) {
    console.error("openUseasyWebChat failed", e);
    Toast("打开客服失败，请稍后重试");
  }
}
